<hpf-diaporama-form
        *ngIf="diaporama"
        [diaporama]="diaporama"
        (create)="onCreate($event)"
    ></hpf-diaporama-form>
<div *ngIf="!diaporama" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>